export default __webpack_public_path__ + "static/media/doc.37c541b1.svg";